import React from "react";
import {
  SIGN_UP_LANDING_PAGE,
  SIGN_UP_OTP_PAGE,
  SIGN_UP_WITH_PASSWORD_PAGE,
  SUCCESS_AUTH
} from "../../../constants/variables";
import SuccessAuth from "../success";
import SignUPLandingPage from "./SignUpLandingPage";
import SignUpOTPPage from "./SignUpWithOTPPage";
import SignUpPasswordPage from "./SignUpWithPasswordPage";

interface formDataInterface {
  firstName: string;
  lastName: string;
  gender: string;
  dob: string | Date;
  country: string;
  emailID: string;
  mobile: string;
  password: string;
}

function SignUpModule(props) {
  const [state, setState] = React.useState(SIGN_UP_LANDING_PAGE);
  const [signUpError, setSignUpError] = React.useState("");
  const [mobile, setMobile] = React.useState("");
  const [formData, setFormData] = React.useState<formDataInterface>({
    firstName: "",
    lastName: "",
    gender: "",
    dob: "",
    country: "India",
    emailID: "",
    mobile: "",
    password: ""
  });

  // ? accepts a state key (such as SIGN_UP_LANDING_PAGE) as param and updates the state with it
  const handleSignUpState = (updatedState: React.SetStateAction<string>) => {
    setState(updatedState);
  };

  // ?
  /**
   * @param e accepts event as a param and updates the mobile number's value
   * declared here because it needs to be accessed both in landing page and OTP page components
   * passed down as a prop to both components
   */
  const handleMobile = (e) => {
    setMobile(e.target.value);
  };

  // ? main body
  return (
    <div className="h-full">
        {state === SIGN_UP_LANDING_PAGE ? (
          <SignUPLandingPage
            handleOpen={props.handleOpen}
            handleState={handleSignUpState}
            handleModule={props.handleModule}
            handleMobile={handleMobile}
            mobile={mobile}
            setFormData={setFormData}
            formData={formData}
            resourceData={props.resourceData}
            setSignUpError={setSignUpError}
            signUpError={signUpError}
          />
        ) : state === SIGN_UP_OTP_PAGE ? (
          <SignUpOTPPage
            handleOpen={props.handleOpen}
            handleState={handleSignUpState}
            mobile={mobile}
            handleMobile={handleMobile}
            setFormData={setFormData}
            formData={formData}
            resourceData={props.resourceData}
            setSignUpError={setSignUpError}
            signUpError={signUpError}
          />
        ) : state === SIGN_UP_WITH_PASSWORD_PAGE ? (
          <SignUpPasswordPage
            handleOpen={props.handleOpen}
            handleState={handleSignUpState}
            mobile={mobile}
            handleMobile={handleMobile}
            setFormData={setFormData}
            formData={formData}
            resourceData={props.resourceData}
            setSignUpError={setSignUpError}
            signUpError={signUpError}
          />
        ) : state === SUCCESS_AUTH ? (
          <SuccessAuth message={props.resourceData.signUpSuccess} handleOpen={props.handleOpen} />
        ) : null}
      </div>
  );
}

export default SignUpModule;
